module.exports = __webpack_public_path__ + "static/media/analytices1.2dbcda6e.png";